import { createPersistedRestate } from './persist.js';
import { restate } from './react.js';
import { restateManager } from './registry.js';
import { createIndexedDBStorage } from './storage/indexeddb.js';
import { createMMKVStorage } from './storage/mmkv.js';

export { createIndexedDBStorage, createMMKVStorage, restate, restateManager };

export function persistedRestate(initialValue, options) {
    return createPersistedRestate(initialValue, options, createMMKVStorage);
}
